import useReveal from "@/hooks/useReveal";

const steps = [
  {
    n: "01",
    icon: "ri-search-eye-line",
    title: "현장조사",
    desc: "전문 인력이 현장을 방문하여 면적, 상태, 환경을 정밀 진단합니다.",
  },
  {
    n: "02",
    icon: "ri-file-list-3-line",
    title: "견적",
    desc: "공법·자재·인력을 명세화한 투명한 견적서를 무료로 제공합니다.",
  },
  {
    n: "03",
    icon: "ri-shake-hands-line",
    title: "계약",
    desc: "표준 도급 계약서로 공사 범위와 하자보수 조건을 명확히 합니다.",
  },
  {
    n: "04",
    icon: "ri-hammer-line",
    title: "시공",
    desc: "전 공정 사진 기록. 각 단계별 자체 품질검사를 병행합니다.",
  },
  {
    n: "05",
    icon: "ri-shield-check-line",
    title: "준공",
    desc: "발주처 입회 검수 후 준공보고서와 시공 자료를 제출합니다.",
  },
  {
    n: "06",
    icon: "ri-customer-service-2-line",
    title: "사후관리",
    desc: "최대 3년까지 정기 점검 및 무상 하자보수를 지원합니다.",
  },
];

export default function Process() {
  const ref = useReveal<HTMLDivElement>();
  return (
    <section className="relative w-full py-24 md:py-32 bg-neutral-50">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div ref={ref} className="reveal max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-px bg-point-500"></span>
            <span className="text-point-600 text-xs font-semibold uppercase tracking-[0.3em]">
              Our Process
            </span>
          </div>
          <h2 className="font-hero text-navy-900 text-3xl md:text-5xl lg:text-6xl leading-tight mb-6">
            시공 진행 6단계
          </h2>
          <p className="text-neutral-600 text-base md:text-lg leading-relaxed">
            문의 접수부터 사후관리까지, 명확한 단계와 산출물로 진행됩니다.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
          {steps.map((s, i) => (
            <div key={s.n} className="relative">
              <div className="h-full p-6 bg-white border border-neutral-200 rounded-2xl hover:border-point-500 hover:-translate-y-2 transition-all duration-500 ease-out">
                <div className="flex items-center justify-between mb-8">
                  <span className="font-hero text-4xl text-neutral-200">{s.n}</span>
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-navy-900 text-point-400">
                    <i className={`${s.icon} text-xl`}></i>
                  </div>
                </div>
                <h3 className="font-hero text-navy-900 text-xl mb-3">{s.title}</h3>
                <p className="text-sm text-neutral-600 leading-relaxed">{s.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden xl:flex absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-6 items-center justify-center bg-white rounded-full border border-neutral-200 z-10">
                  <i className="ri-arrow-right-s-line text-neutral-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}